import React from 'react';
import { WorkshopFlyerBullet } from '../../data/workshopFlyerContent';
import styles from '../../styles/workshopFlyerPage.module.css';

interface WorkshopFlyerBulletsProps {
  items: WorkshopFlyerBullet[];
  className?: string;
}

const WorkshopFlyerBullets: React.FC<WorkshopFlyerBulletsProps> = ({ items, className }) => (
  <ul className={`${styles.flyerBulletList}${className ? ` ${className}` : ''}`}>
    {items.map((item) => (
      <li key={item.id} className={styles.flyerBullet}>
        <strong className={styles.flyerBulletLead}>{item.lead}</strong>{' '}
        <span className={styles.flyerBulletDetail}>{item.detail}</span>
      </li>
    ))}
  </ul>
);

export default WorkshopFlyerBullets;
